import React, {useState} from 'react';
import { useNavigate} from 'react-router-dom';

// Small arrow in the top-left corner that takes the user back to the landing page
function BackArrow() {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      onClick={() => navigate('/')}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label="Back to main page"
      title="Back to main page"
      style={{
        ...styles.button,
        backgroundColor: isHovered ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.25)',
      }}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 12H5" />
        <path d="M12 19l-7-7 7-7" />
      </svg>
    </button>
  );
}

// Inline styles
const styles = {
  button: {
    position: 'absolute', // Scrolls away with the page so it never covers content
    top: '10px',
    left: '10px',
    width: '36px',
    height: '36px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    border: 'none',
    borderRadius: '50%',
    cursor: 'pointer',
    transition: 'background-color 0.3s',  // Smooth background color transition
  },
};

export default BackArrow;
